/**
 * Flags that indicate the location and characteristics of an attachment.
 */
export type RemoteAttachmentFlags = "None" | "Remote"
